<template>
  <!-- eslint-disable vue/valid-v-slot -->
  <v-card class="pa-6" flat>
    <v-row class="mt-2 mr-2">
      <v-btn
        icon
        class="hidden-xs-only ml-3"
        color="primary"
        @click="$router.push('/dashboard')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <p class="text-h5 bold ml-4">COMUNICADOS</p>
      <v-spacer />
      <v-dialog
        v-model="dialog"
        persistent
        :max-width="$vuetify.breakpoint.mdAndDown ? '' : '40vw'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="bold"
            color="secondary"
            large
            rounded
            v-bind="attrs"
            v-on="on"
            @click="dialog = true"
          >
            <v-icon>mdi-plus</v-icon>
            <span class="login pa-2">NOVO COMUNICADO</span>
          </v-btn>
        </template>
        <v-form ref="newAnnouncementForm" v-model="valid" lazy-validation>
          <v-card>
            <v-toolbar color="primary" dark>Novo comunicado</v-toolbar>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="form.title"
                      label="Título*"
                      required
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.description"
                      label="Descrição*"
                      required
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="form.date"
                          label="Data do Comunicado*"
                          v-bind="attrs"
                          @blur="date = parseDate(form.date)"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="dataDoComunicado"
                        no-title
                        @input="menu = false"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="closeModal">
                Fechar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="edit ? editAnnouncement() : createAnnouncement()"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>

    <v-data-table class="mt-12" :headers="headers" :items="announcements">
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon large v-bind="attrs" v-on="on" @click="openEdit(item)">
              <v-icon class="mr-2"> mdi-pencil-outline </v-icon>
            </v-btn>
          </template>
          <span>Editar comunicado</span>
        </v-tooltip>
        <v-dialog
          v-model="modalStudent"
          persistent
          :max-width="$vuetify.breakpoint.mdAndDown ? '' : '70vw'"
        >
          <template v-slot:activator="{ on: onDialog, attrs: attrsDialog }">
            <v-tooltip top>
              <template
                v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }"
              >
                <v-btn
                  icon
                  large
                  v-bind="{ ...attrsDialog, ...attrsTooltip }"
                  @click="openModalStudent(item)"
                  v-on="{ ...onDialog, ...onTooltip }"
                >
                  <v-icon> mdi-account-multiple-outline </v-icon>
                </v-btn>
              </template>
              <span>Editar usuários</span>
            </v-tooltip>
          </template>
          <v-card>
            <v-toolbar color="primary" dark
              >Educandos vinculados ao comunicado</v-toolbar
            >
            <v-card-text>
              <br />
              <p>
                *Selecione os usuários a serem vinculados ao comunicado clicando
                no checkbox disponível em cada linha da tabela.
              </p>

              <v-data-table
                v-model="selectedStudents"
                class="mt-12"
                item-key="id"
                :headers="headersStudent"
                :items="users"
                show-select
                @item-selected="onSelectStudent"
              >
                <template v-slot:header.data-table-select> </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="closeModalStudent">
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              v-bind="attrs"
              v-on="on"
              @click="deleteAnnouncement(item)"
            >
              <v-icon> mdi-delete-outline </v-icon>
            </v-btn>
          </template>
          <span>Excluir comunicado</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

// eslint-disable-next-line import/no-cycle
import {
  getAnnouncement,
  getAnnouncementById,
  createAnnouncement,
  editAnnouncement,
  removeAnnouncement,
  createUserAnnouncement,
  deleteUserAnnouncement,
} from '@/services/announcement';

// eslint-disable-next-line import/no-cycle
import { getUsers } from '@/services/user';

import { stringRules } from '@/utils/Rules';

export default {
  name: 'Announcements',
  data: () => ({
    stringRules,
    edit: false,
    valid: false,
    dialog: false,
    menu: false,
    form: {
      title: '',
      description: '',
      date: '',
    },
    selectedStudents: [],
    headers: [
      {
        text: 'Código',
        align: 'start',
        filterable: true,
        value: 'id',
        class: 'primary',
      },
      {
        text: 'Título',
        align: 'start',
        filterable: true,
        value: 'title',
        class: 'primary',
      },
      {
        text: 'Descrição',
        align: 'start',
        filterable: true,
        value: 'description',
        class: 'primary',
      },
      {
        text: 'Data do Comunicado',
        align: 'start',
        filterable: true,
        value: 'date',
        class: 'primary',
      },
      { text: 'Ações', value: 'actions', sortable: false, class: 'primary' },
    ],
    announcements: [],
    modalStudent: false,
    announcementsStudent: [],
    headersStudent: [
      {
        text: 'Nome',
        align: 'start',
        filterable: true,
        value: 'firstName',
        class: 'primary',
      },
      {
        text: 'Sobrenome',
        align: 'start',
        filterable: true,
        value: 'lastName',
        class: 'primary',
      },
      {
        text: 'CPF',
        align: 'start',
        filterable: true,
        value: 'cpf',
        class: 'primary',
      },
      {
        text: 'Perfil',
        align: 'start',
        filterable: true,
        value: 'profile.description',
        class: 'primary',
      },
    ],
    users: [],
    dataDoComunicado: '',
  }),
  computed: {
    ...mapGetters({ user: 'user/getUser' }),
  },
  watch: {
    dataDoComunicado() {
      this.form.date = this.formatDate(this.dataDoComunicado);
    },
  },
  mounted() {
    this.getAnnouncements();
  },
  methods: {
    ...mapActions('loading', ['showLoading', 'hideLoading']),
    async getUsers() {
      try {
        this.showLoading();
        const { data } = await getUsers({ name: '', profileId: '' });

        this.users = data.rows;
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar usuários.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    async getAnnouncements() {
      try {
        this.showLoading();
        const { data } = await getAnnouncement();

        this.announcements = data.map((x) => ({
          ...x,
          date: this.formatDateToShow(x.date),
        }));
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar os comunicados.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    async getAnnouncementById(id) {
      try {
        this.showLoading();
        const { data } = await getAnnouncementById(id);
        this.selectedStudents = data.users;
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar os usuários vinculados ao comunicado.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    async createAnnouncement() {
      try {
        this.showLoading();
        const resp = await createAnnouncement({
          ...this.form,
          date: this.parseDateEs(this.form.date),
          createdById: this.user.id,
        });
        if (resp && resp.success) {
          this.$root.vtoast.show({
            message: `Comunicado ${this.form.title} adicionado com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
          this.dialog = false;
          this.getAnnouncements();
        } else {
          this.$root.vtoast.show({
            message: 'Erro ao criar o comunicado.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao criar o comunicado.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    openEdit(item) {
      this.dialog = true;
      this.form = { ...item };
      this.edit = true;
    },
    async editAnnouncement() {
      try {
        this.showLoading();
        const resp = await editAnnouncement({
          ...this.form,
          date: this.parseDateEs(this.form.date),
        });
        if (resp && resp.success) {
          this.$root.vtoast.show({
            message: `Comunicado ${this.form.title} editado com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
          this.dialog = false;
          this.form = {
            title: '',
            description: '',
            date: '',
            address: '',
          };
          this.getAnnouncements();
        } else {
          this.$root.vtoast.show({
            message: 'Erro ao editar o comunicado.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao editar o comunicado.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    async deleteAnnouncement(item) {
      try {
        this.showLoading();
        await removeAnnouncement({
          id: item.id,
        });
        this.$root.vtoast.show({
          message: `Comunicado ${this.form.title} excluído com sucesso.`,
          top: true,
          right: true,
          show: true,
          color: 'success',
        });
        this.dialog = false;
        this.form = {
          title: '',
          description: '',
          date: '',
          address: '',
        };
        this.getAnnouncements();
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao excluir o comunicado.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    closeModal() {
      this.dialog = false;
      this.edit = false;
    },
    openModalStudent(item) {
      this.modalStudent = true;
      this.form = item;
      this.getUsers();
      this.getAnnouncementById(item.id);
    },
    async onSelectStudent({ item, value }) {
      if (value === true) {
        try {
          this.showLoading();
          await createUserAnnouncement({
            userId: item.id,
            announcementId: this.form.id,
          });
          this.$root.vtoast.show({
            message: `Usuário vinculado ao comunicado com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
        } catch (e) {
          this.$root.vtoast.show({
            message: 'Erro ao criar o vínculo entre usuário e comunicado.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        } finally {
          this.hideLoading();
        }
      } else {
        try {
          this.showLoading();
          await deleteUserAnnouncement({
            userId: item.id,
            announcementId: this.form.id,
          });
          this.$root.vtoast.show({
            message: `Usuário desvinculado ao comunicado com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
        } catch (e) {
          this.$root.vtoast.show({
            message: 'Erro ao desvincular usuário e comunicado.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        } finally {
          this.hideLoading();
        }
      }
    },
    closeModalStudent() {
      this.modalStudent = false;
      this.form = {
        title: '',
        description: '',
        date: '',
        address: '',
      };
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    formatDateToShow(timestamp) {
      const date = new Date(timestamp);
      const day = date.getUTCDate().toString().padStart(2, '0');
      const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
      const year = date.getUTCFullYear();

      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    parseDateEs(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${day.padStart(2, '0')}-${month.padStart(2, '0')}`;
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}

*
  >>> .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  background-color: #137cc0;
  color: white;
}

*
  >>> .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th:hover {
  color: white;
}

* >>> .mdi-arrow-up::before {
  color: white;
}
</style>
